import { render, staticRenderFns } from "./Around.vue?vue&type=template&id=52661cc5&scoped=true&"
import script from "./Around.vue?vue&type=script&lang=js&"
export * from "./Around.vue?vue&type=script&lang=js&"
import style0 from "./Around.vue?vue&type=style&index=0&id=52661cc5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52661cc5",
  null
  
)

export default component.exports